// @ngInject
Models.FileSectionsCollection = function FileSectionsCollection(BaseCollection) {

    return Class(BaseCollection, {
            constructor: function constructor() {
                this.constructor.$super.call(this);
                this._collection.__className = 'FileSectionsCollection';
                this._collection.__childsType = 'FileSectionModel';
                this._collection.shouldMergeOnLoad = true;
                return this._collection;
            }
        }
    );
};